import React from 'react';
import { translate } from 'react-i18next';

import Form from '../../../user/edit/Form';
import Modal from '../../../common/Modal';
import * as API from '../../../core/api';
import { catchFormErrors } from '../../../utils/form-errors';

class Edit extends React.Component {
  state = { isModalOpen: false };

  handleModalOpen = () => this.setState({ isModalOpen: true });
  handleModalClose = () => this.setState({ isModalOpen: false });

  handleSubmit = (formValues) => {
    const { onSuccess, invite } = this.props;

    const promises = [];
    promises.push(
      API.post(`invites/${invite.code}`, {
        userMeta: {
          ...formValues,
          urls: formValues.urls
            ? formValues.urls.split(',').map((url) => url.trim())
            : [],
        },
      })
    );

    const isNewAvatarSelected = typeof formValues.avatarUrl === 'object';
    if (isNewAvatarSelected) {
      const data = new FormData();
      data.append('avatar', formValues.avatarUrl, formValues.avatarUrl.name);

      promises.push(API.post(`invites/${invite.code}/avatar`, data));
    }

    return Promise.all(promises)
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  render() {
    const { t, invite } = this.props;
    const { isModalOpen } = this.state;

    return (
      <React.Fragment>
        <button className="c-btn  c-btn--edit" onClick={this.handleModalOpen} />

        <Modal
          isOpen={isModalOpen}
          onRequestClose={this.handleModalClose}
          title={t('admin.editInviteModalTitle')}
        >
          <Form
            okButtonText={t('admin.editInviteModalBtn')}
            onSubmit={this.handleSubmit}
            initialValues={{
              ...invite.userMeta,
              email: invite.email,
              urls: invite.userMeta.urls.join(', '),
            }}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default translate()(Edit);



// WEBPACK FOOTER //
// ./src/admin/invites/edit/index.js